// extracted by mini-css-extract-plugin
export var disabled = "_10-a";
export var hierarchyLinkGray = "_10-4";
export var hierarchyLinkUnderline = "_10-3";
export var hierarchyPrimary = "_10-0";
export var hierarchySecondary = "_10-1";
export var hierarchyTertiary = "_10-2";
export var pressed = "_10-6";
export var themeAction = "_10-5";
export var themeDestructive = "_10-8";
export var themeNormal = "_10-7";
export var themeSuccess = "_10-9";